import React from 'react';
import { Modal, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import '../translations.js';
import './knowledgeWarningModal.css';

const KnowledgeWarningModal = ({ open, onConfirm, onCancel, message }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const warningText =
    message ||
    t('no_knowledge_warning') ||
    'No URL or documents provided. The agent will have no knowledge. Do you want to continue?';

  const confirmLabel = t('confirm') || 'Confirm';
  const cancelLabel = t('cancel') || 'Cancel';
  const title = t('no_knowledge_warning_title') || 'Continue without knowledge?';

  return (
    <Modal open={open} onClose={onCancel}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'white',
          borderRadius: '10px',
          boxShadow: 24,
          padding: isMobile ? '20px' : '30px',
          width: isMobile ? '85%' : '90%',
          maxWidth: 420,
        }}
      >
        <div className="knowledge-warning-title">
          <h2>{title}</h2>
        </div>
        <p className="knowledge-warning-message">{warningText}</p>
        <div className="knowledge-warning-actions">
          <Button
            onClick={onCancel}
            variant="outlined"
            sx={{
              borderColor: '#5616ea',
              color: '#5616ea',
              '&:hover': {
                borderColor: '#4a14d6',
                backgroundColor: '#f0f0f0',
              },
            }}
          >
            {cancelLabel}
          </Button>
          <Button
            onClick={onConfirm}
            variant="contained"
            sx={{
              backgroundColor: '#5616ea',
              '&:hover': {
                backgroundColor: '#4a14d6',
              },
            }}
          >
            {confirmLabel}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default KnowledgeWarningModal;
